export default __webpack_public_path__ + "static/media/desktop.02a8680c.svg";